"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utiliser sur les composants qui doivent contenir le résultat d'une formule
 */
var expr_eval_1 = require("expr-eval");
exports.default = {
    props: ["formula"],
    mounted: function mounted() {
        var _this = this;
        this.formulaResult = {};
        this.getFormulaFields().forEach(function (f) {
            return _this.formulaResult[f] = null;
        });
        var fields = Object.keys(this.formulaResult);
        var expr = this.getFormulaExpression();
        if (fields.length > 0) {
            this.$root.$on("formula-change", function (change) {
                if (fields.indexOf(change.name) != -1) {
                    _this.formulaResult[change.name] = change.value;
                    var result = expr.evaluate(_this.formulaResult);
                    if (isNaN(result)) {
                        _this.setFormulaResult("");
                    } else {
                        _this.setFormulaResult(result);
                    }
                }
            });
        }
    },
    methods: {
        setFormulaResult: function setFormulaResult(result) {
            throw Error("methods.setFormulaResult doit être implémenté dans les composants Vue ayant le mixin FormulaOutput");
        },
        getFormulaExpression: function getFormulaExpression() {
            if (!this.formula) {
                return null;
            }
            var parser = new expr_eval_1.Parser();
            return parser.parse(this.formula);
        },
        getFormulaFields: function getFormulaFields() {
            var expr = this.getFormulaExpression();
            if (!expr) {
                return [];
            }
            return expr.variables();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/Mixins/FormulaOutput.ts
// module id = 549
// module chunks = 0